import { render, staticRenderFns } from "./intermediaryList.vue?vue&type=template&id=637ef7ca&scoped=true"
import script from "./intermediaryList.vue?vue&type=script&lang=js"
export * from "./intermediaryList.vue?vue&type=script&lang=js"
import style0 from "./intermediaryList.vue?vue&type=style&index=0&id=637ef7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ef7ca",
  null
  
)

export default component.exports